/**
 * Validacion y limpieza de telefonos, compartida por los formularios que los
 * piden: crear empresa, editar empresa y el numero de WhatsApp.
 *
 * El mismo formato esta validado en el backend (CompanyController): digitos,
 * un + opcional al inicio, espacios y guiones, entre 7 y 30 caracteres. Si se
 * cambia aqui hay que cambiarlo alla, porque el front se puede saltar con un
 * POST a mano y la validacion de verdad es la del servidor.
 */

export const FORMATO_TELEFONO = /^\+?[\d\s-]{7,30}$/

/** Quita del texto todo lo que no pueda ir en un telefono */
export function limpiarTelefono(valor) {
  if (valor === null || valor === undefined) {
    return valor
  }

  // El + solo tiene sentido al principio; en medio del numero sobra
  return String(valor)
    .replace(/[^\d+\s-]/g, '')
    .replace(/(?!^)\+/g, '')
}

/**
 * Devuelve el error del campo como arreglo, que es lo que espera
 * :error-messages de Vuetify. Vacio significa que esta bien.
 *
 * Se usa :error-messages y no :rules a proposito: los formularios del
 * proyecto no llaman a validate(), asi que una :rules pinta el error pero
 * deja guardar igual. Con el arreglo calculado, el guardado lo bloquea el
 * metodo que guarda.
 */
export function errorTelefono(valor, { obligatorio = true, mensajeVacio = null } = {}) {
  const numero = (valor || '').trim()

  if (!numero) {
    return obligatorio ? [mensajeVacio || 'El teléfono es obligatorio'] : []
  }
  if (!FORMATO_TELEFONO.test(numero)) {
    return ['Escribe un número válido']
  }
  return []
}

export default { FORMATO_TELEFONO, limpiarTelefono, errorTelefono }
